import { render } from "./OrderOnMapList.vue?vue&type=template&id=5085f0d9&scoped=true&ts=true"
import script from "./OrderOnMapList?vue&type=script&lang=ts"
export * from "./OrderOnMapList?vue&type=script&lang=ts"

import "./OrderOnMapList.vue?vue&type=style&index=0&id=5085f0d9&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5085f0d9"]])

export default __exports__